import React, { useState, useEffect } from 'react'
import { createPortal } from 'react-dom'

export default function BottomSheet({ isOpen, onClose, title, headerAction, children }) {
  const [show, setShow] = useState(false)

  useEffect(() => {
    if (!isOpen) { setShow(false); return }
    let raf1, raf2
    raf1 = requestAnimationFrame(() => {
      raf2 = requestAnimationFrame(() => setShow(true))
    })
    return () => { cancelAnimationFrame(raf1); cancelAnimationFrame(raf2) }
  }, [isOpen])

  function handleClose() {
    setShow(false)
    setTimeout(onClose, 260)
  }

  if (!isOpen) return null

  return createPortal(
    <>
      <div
        onClick={handleClose}
        className="fixed top-0 left-0 right-0 bottom-16 z-[998]"
        style={{ background: `rgba(0,0,0,${show ? 0.4 : 0})`, transition: 'background 0.26s ease' }}
      />

      <div
        className="fixed bottom-16 left-0 right-0 bg-white rounded-t-[16px] z-[999] flex flex-col max-h-[70vh]"
        style={{ transform: show ? 'translateY(0)' : 'translateY(100%)', transition: 'transform 0.26s ease' }}
      >
        <div className="flex items-center px-6 pt-3 pb-1 shrink-0">
          <button onClick={handleClose} className="p-1 bg-transparent border-none cursor-pointer focus:outline-none">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path d="M1 1l12 12M13 1L1 13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" className="text-woperty-dark"/>
            </svg>
          </button>
          {title
            ? <span className="flex-1 text-center font-inter text-[16px] font-bold text-woperty-dark">{title}</span>
            : <span className="flex-1" />
          }
          {headerAction || <div className="w-[22px]" />}
        </div>

        <div className="flex-1 min-h-0 overflow-y-auto scroll-thin">
          {children}
        </div>
      </div>
    </>,
    document.body
  )
}
